import { IProject, ISortedOrders } from '../types';

export const getUpdatedProjectList = (
  newState: ISortedOrders,
  itemId: string,
) => {
  const projectList: IProject[] = [];

  Object.entries(newState.products).forEach(([date, brands]) => {
    Object.entries(brands).forEach(([brand, projects]) => {
      Object.entries(projects).forEach(([projectId, { itemID, project }]) => {
        if (itemID === itemId) {
          delete newState.products[date][brand][projectId];
        } else if (!projectList.find(({ id }) => id === projectId)) {
          projectList.push(project);
        }
      });

      if (Object.keys(newState.products[date][brand]).length === 0) {
        delete newState.products[date][brand];
      }
    });

    if (Object.keys(newState.products[date]).length === 0) {
      delete newState.products[date];
    }
  });

  return projectList;
};
